<template>
	<div class="xs-12">
		<!-- Headline -->
		<div class="xs-12 ta1 fs5 fw7 lh125 mb2 bg4 p4">
			{{ $t("create_permission_group") }}
		</div>

		<form class="p4" @submit.prevent>
			<!-- Name -->
			<div class="xs-12">
				<label for="name" class="lh125 fw7 mb1">{{ $t("name") }}</label>
				<j-base-input-text
					name="name"
					id="name"
					v-model="payload.name"
					:status="errors.first('name') ? 'error' : null"
					v-validate="'required'"
				/>
			</div>

			<!-- Description -->
			<div class="xs-12 mt6">
				<label for="description" class="lh125 fw7 mb1">{{
					$t("description")
				}}</label>
				<j-base-input-text
					id="description"
					name="description"
					:status="errors.first('description') ? 'error' : null"
					v-model="payload.description"
					v-validate="'required'"
				/>
			</div>

			<!-- Button -->
			<div class="xs-12 mt6">
				<j-button :isLoading="isLoading" @click="createPermissionGroup">
					{{ $t("save") }}
				</j-button>
			</div>
		</form>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText/"
import JButton from "@/components/JButton/"
import api from "@/modules/users/api/"

export default {
	components: {
		JBaseInputText,
		JButton
	},

	data() {
		return {
			isLoading: false,
			payload: {
				name: null,
				description: null
			}
		}
	},

	methods: {
		async createPermissionGroup() {
			// Validate form
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.isLoading = true
			const res = await api.createPermissionGroup({
				createPermissionGroupInput: this.payload
			})
			this.isLoading = false

			if (res.errors) this.$store.dispatch("showError", res.errors)

			this.$emit("created")
		}
	}
}
</script>
